import GradeLessonPage from '../components/GradeLessonPage';
import { grade10Data } from './data';

export default function Grade10Page() {
  return (
    <GradeLessonPage
      grade="Grade 10"
      gradeLabel="Grade 10"
      gradeColor="violet"
      topics={grade10Data}
      prevGrade={{ label: 'Grade 9', path: '/grade/9' }}
      nextGrade={{ label: 'Algebra 1', path: '/algebra1' }}
    />
  );
}
